import {gql} from '@apollo/client';

export const GET_ALL_MINI_FEEDBACKS = gql`
  query GetAllMiniFeedbacks($input: GetAllMiniFeedbacksInput) {
    getAllMiniFeedbacks(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithMiniFeedbacks {
        pagination {
          total
        }
        data {
          id
          title
          featureId
          isActive
          description
          triggers {
            clickThreshold
            timeOnFeatureThreshold
          }
          totalQuestions
          triggerInAppReviewAfterSubmit
          totalResponses
          multilang {
            id
            parent
            language
            title
            description
            createdAt
            updatedAt
          }
          isDeleted
        }
      }
    }
  }
`;

export const CREATE_MINI_FEEDBACK = gql`
  mutation CreateMiniFeedback($input: CreateMiniFeedbackInput!) {
    createMiniFeedback(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithMiniFeedback {
        message
      }
    }
  }
`;

export const UPDATE_MINI_FEEDBACK = gql`
  mutation UpdateMiniFeedback($input: UpdateMiniFeedbackInput!) {
    updateMiniFeedback(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithMiniFeedback {
        message
      }
    }
  }
`;

export const DELETE_MINI_FEEDBACK = gql`
  mutation DeleteMiniFeedback($input: GetMiniFeedbackFilterInput!) {
    deleteMiniFeedback(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
    }
  }
`;

export const GET_MINI_FEEDBACK_BY_ID = gql`
  query GetMiniFeedbackById($input: GetMiniFeedbackFilterInput!) {
    getMiniFeedbackById(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithMiniFeedback {
        data {
          id
          title
          description
          featureId
          isActive
          totalQuestions
          totalResponses
          isDeleted
          language
          triggerInAppReviewAfterSubmit
          createdAt
          updatedAt
          questions {
            id
            feedbackId
            questionText
            questionType
            options {
              label
              value
            }
            multilang {
              language
              questionText
              options {
                label
                value
              }
            }
            order
            isDeleted
            createdAt
            updatedAt
          }
          triggers {
            clickThreshold
            timeOnFeatureThreshold
          }
        }
      }
    }
  }
`;

export const ADD_QUESTION_TO_MINI_FEEDBACK = gql`
  mutation AddMiniFeedbackQuestions($input: AddMiniFeedbackQuestionsInput!) {
    addMiniFeedbackQuestions(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithMiniFeedback {
        message
      }
    }
  }
`;

export const MINI_FEEDBACK_RESPONSES = gql`
  query GetMiniFeedbackResponses($input: GetMiniFeedbackResponsesInput!) {
    getMiniFeedbackResponses(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithMiniFeedbackResponses {
        pagination {
          total
        }
        data {
          id
          feedbackId
          user {
            id
            username
            firstName
            lastName
            email
            imageUrl
          }
          answers {
            questionId
            questionText
            answer
          }
          featureId
          createdAt
        }
      }
    }
  }
`;

export const EXPORT_MINI_FEEDBACK_RESPONSES = gql`
  mutation ExportMiniFeedbackResponses(
    $input: ExportMiniFeedbackResponsesInput!
  ) {
    exportMiniFeedbackResponses(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithMiniFeedbackResponseExport {
        message
      }
    }
  }
`;

export const UPDATE_MINI_FEEDBACK_QUESTION = gql`
  mutation UpdateMiniFeedbackQuestions(
    $input: UpdateMiniFeedbackQuestionsInput!
  ) {
    updateMiniFeedbackQuestions(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithMiniFeedback {
        message
      }
    }
  }
`;

export const DELETE_MINI_FEEDBACK_QUESTION = gql`
  mutation DeleteMiniFeedbackQuestion($input: GetMiniFeedbackFilterInput!) {
    deleteMiniFeedbackQuestion(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithMiniFeedback {
        message
      }
    }
  }
`;

export const TOGGLE_MINI_FEEDBACK_STATUS = gql`
  mutation ToggleMiniFeedbackStatus($input: ToggleMiniFeedbackStatusInput!) {
    toggleMiniFeedbackStatus(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithMiniFeedback {
        message
      }
    }
  }
`;
